import React, {
    useState, useEffect, useCallback, useContext
} from 'react'
import { useHistory } from 'react-router-dom'
import { format } from 'date-fns'
import { FiExternalLink } from 'react-icons/fi'

import { api, authHeaders } from '~/services/api'

import BoxList from '~/components/BoxList'
import Modal from '~/components/Modal'
import { Juridico } from '~/components/Associado'

import { GlobalContext } from '~/contexts/GlobalContext'

export default function ({
    compacto = true, pessoa, onIconClick, showTitle = true
}) {
    const { user } = useContext(GlobalContext)

    const history = useHistory()

    const [demandas, setDemandas] = useState([])
    const [showDetalhe, setShowDetalhe] = useState(false)

    const loadCausasJuridicas = useCallback(async () => {
        const response = await api.get('acao_juridica', {
            params: { associado_id: pessoa.associado.id.toString() },
            ...authHeaders()
        })

        setDemandas(response.map(demanda => ({
            id: demanda.id,
            numero: `#${demanda.id}`,
            assunto: demanda.assunto || '-',
            data_inicio: format(new Date(demanda.data_inicio), 'dd/MM/yyyy'),
            advogado: demanda.advogado,
            status: demanda.status
        })))
    }, [pessoa])

    useEffect(() => {
        loadCausasJuridicas()
    }, [])

    return (
        <>
            {compacto ? (
                <>
                    <BoxList
                        compacto
                        title={showTitle ? 'Demandas Jurídicas' : ''}
                        onIconClick={onIconClick === undefined ? (() => { setShowDetalhe(true) }) : onIconClick}
                        headers={[
                            { name: 'assunto', value: 'Tipo de ação', centered: true },
                            { name: 'status', value: 'Status', centered: true }
                        ]}
                        data={demandas}
                    />

                    <Modal
                        isOpen={showDetalhe}
                        handleClose={() => setShowDetalhe(false)}
                        title="Demandas Jurídicas"
                        closeOnOverlayClick
                    >
                        <Juridico compacto={false} pessoa={pessoa} showTitle={false} />
                    </Modal>
                </>
            ) : (
                <BoxList
                    title={showTitle ? 'Demandas Jurídicas' : ''}
                    headers={[
                        { name: 'numero', value: '', centered: true },
                        { name: 'assunto', value: 'Tipo de ação', centered: true },
                        { name: 'data_inicio', value: 'Data de início', centered: true },
                        { name: 'advogado', value: 'Advogado responsável', centered: true },
                        { name: 'status', value: 'Status', centered: true }
                    ]}
                    data={demandas}
                    actions={![3, 11, 12, 15].includes(user?.perfil.id) ? [
                        {
                            action: item => {
                                history.push(`/atendimento/${item.id}`)
                            },
                            name: 'Visualizar',
                            icon: FiExternalLink,
                            iconSize: 16
                        }
                    ] : []}
                />
            )}
        </>
    )
}
